<div #modalElement class="modal fade" tabindex="-1" aria-labelledby="modalHeader" aria-hidden="true">
  @if ({config: currentModal$ | async}; as modal) {
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered"
        [class.modal-fullscreen-md-down]="modal.config?.fullscreenOnMobile"
        [class.modal-sm]="modal.config?.size === 'sm'"
        [class.modal-lg]="modal.config?.size === 'lg'"
        [class.modal-xl]="modal.config?.size === 'xl'">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="modalHeader">
            @if (modal.config?.dangerous) {
              <i class="bi bi-exclamation-octagon-fill text-danger me-2"></i>
            }
            {{modal.config?.heading}}
          </h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        @if (modal.config?.template; as template) {
          <ng-container *ngComponentOutlet="template; injector: modal.config?.injector"></ng-container>
        } @else {
          <div class="modal-body"></div>
        }
      </div>
    </div>
  }
</div>
